import { render } from "./Menu.vue?vue&type=template&id=ea29540a&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=ea29540a&lang=scss&scoped=true"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea29540a"]])

export default __exports__